import { Injectable, EventEmitter } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs/Rx";
import { Http, RequestOptions, Headers, Response } from "@angular/http";
import { Router } from "@angular/router";
import { environment } from "../../../../environments/environment";

// Interfaces
import {
	IService,
	IApplication,
	IState,
	IStateModel,
	IStatesModel,
	ICountriesModel,
	ICountry,
	ICountryModel,
	IError,
	IStepModel,
	IApplicationModel,
	IApplicationsModel,
	IReviewerModel,
	IReviewersModel,
	ILevel_CMSMetadata,
	ILevelStep_CMSMetadata,
	ILevelStepSection_CMSMetadata,
	IQuestionModel,
	INotify
} from "../../interfaces";
// enums
import { RoleEnum, ApplicationStatusEnum } from "../../enums";
import { dialogTag } from "../../types";
// Services
import { LogService } from "../log/log.service";
import { ServerService } from "../server/server.service";
import { LoaderService } from "../loader/loader.service";
import { HelperService } from "../helper/helper.service";
import { PromptService } from "../prompt/prompt.service";
import { UserService } from "../user/user.service";
import { ApplicationService } from "../application/application.service";
import { TOUCHEND_HIDE_DELAY } from "@angular/material";

@Injectable()
export class ReviewerService implements IService {
	// implements IService
	name = "ReviewerService";
	test(name, value) {
		console.log("testing", name, value);
	}

	// implements local variables

	public AssignToPanels$ = new EventEmitter<dialogTag>(true);

	private _filesAreUploaded: BehaviorSubject<boolean> = new BehaviorSubject(
		false
	);

	private _allReviewers: BehaviorSubject<
		IReviewerModel[]
	> = new BehaviorSubject<IReviewerModel[]>(undefined);
	private _qcs: BehaviorSubject<IReviewerModel[]> = new BehaviorSubject<
		IReviewerModel[]
	>(undefined);
	private _sites: BehaviorSubject<IReviewerModel[]> = new BehaviorSubject<
		IReviewerModel[]
	>(undefined);
	private _panels: BehaviorSubject<IReviewerModel[]> = new BehaviorSubject<
		IReviewerModel[]
	>(undefined);
	private _boards: BehaviorSubject<IReviewerModel[]> = new BehaviorSubject<
		IReviewerModel[]
	>(undefined);
	private _aceps: BehaviorSubject<IReviewerModel[]> = new BehaviorSubject<
		IReviewerModel[]
	>(undefined);

	private _members: BehaviorSubject<IReviewerModel[]> = new BehaviorSubject<
		IReviewerModel[]
	>(undefined);

	SelectPanelDialogOpen = false;

	_updateStatusTo: ApplicationStatusEnum = ApplicationStatusEnum.None;

	//  private _data: {
	//    _detailResolver: IDetailResolver;
	//  };

	private _reviewers: {
		All: IReviewerModel[];
		QCs: IReviewerModel[];
		Panels: IReviewerModel[];
		Sites: IReviewerModel[];
		Boards: IReviewerModel[];
		Aceps: IReviewerModel[];
	};

	// private _currentReviewers: {
	// 	QCs: IReviewerModel[],
	// 	Panels: IReviewerModel[],
	// 	Sites: IReviewerModel[],
	// 	Boards: IReviewerModel[],
	// };

	constructor(
		private _serverSrv: ServerService,
		private _logSrv: LogService,
		private _loaderSrv: LoaderService,
		private _promptSrv: PromptService,
		private _helperSrv: HelperService,
		private _userSrv: UserService
	) { }

	get QCS() {
		return this._qcs.asObservable();
	}

	get PANELS() {
		return this._panels.asObservable();
	}

	get SITES() {
		return this._sites.asObservable();
	}

	get BOARDS() {
		return this._boards.asObservable();
	}

	get ACEPS() {
		return this._aceps.asObservable();
	}

	get REVIEWERS() {
		return this._allReviewers.asObservable();
	}

	get MEMBERS() {
		return this._members.asObservable();
	}

	get Reviewers() {
		return [
			...this._reviewers.QCs,
			...this._reviewers.Panels,
			...this._reviewers.Sites,
			...this._reviewers.Boards
		];
	}

	// get CurrentReviewers() {
	// 	if (!this._currentReviewers) {
	// 		throw new ReferenceError(
	// 			'Cannot use CurrentReviewers. _currentReviewers is undefined');
	// 	}
	// 	return this._currentReviewers;
	// }

	get PostingReviewers() {
		// return [...this._reviewers.Boards.filter(b => b.Reviewer.Selected === true),
		// ...this._reviewers.Panels.filter(p => p.Reviewer.Selected === true)];

		return [
			...this._reviewers.QCs,
			...this._reviewers.Panels,
			...this._reviewers.Sites,
			...this._reviewers.Boards
		].filter(b => b.Reviewer.Selected === true);
	}

	get FILES_ARE_UPLOADED() {
		return this._filesAreUploaded.asObservable();
	}

	set FilesAreUploaded(value: boolean) {
		this._filesAreUploaded.next(value);
	}
	// set SelectPanelDialogOpen(value: boolean) {
	//   this._selectPanelDialogOpen = value;
	// }

	// get SelectPanelDialogOpen() {
	//   return this._selectPanelDialogOpen;
	// }

	/**
	 * loads discussions for application
	 * loads Internal/External depending on user role
	 */

	// LoadDiscussions() {
	// 	// this._discussionService.get(
	// 	//   this._data._detailResolver.application.ApplicationId,
	// 	//   (this._applicationSrv.actAsAcep
	// 	// 	? DiscussionEnum.Location.Internal : DiscussionEnum.Location.External),
	// 	//   this._applicationSrv.isApplicant)
	// 	//   .subscribe(disx => {
	// 	// 	this._loggerService.Debug(this.name, ['LoadDiscussions', disx]);
	// 	//   }, err => {
	// 	// 	this._loggerService.Error(this.name, ['LoadDiscussions', err]);
	// 	//   });
	// }

	GetReviewers(applicationId: string) {
		//: Promise<IReviewersModel> {
		this._logSrv.Debug(this.name, ["get list or reviewers "]);

		let endPoint = `${
			this._helperSrv.ApiLocation
			}reviewer/key/${applicationId}`;

		return this._serverSrv
			.GetWithAuth("A000000", endPoint)
			.map(
				response => {
					const body = response.json();
					this._logSrv.Debug(this.name, [
						"get reviewers",
						{ response: response, body: body }
					]);
					const model = <IReviewersModel>body.Data;
					const reviewers = model;
					this._updateReviewers(reviewers);
				},
				Err => {
					this._logSrv.Error(this.name, ["getReviewers Error", Err]);
					return undefined;
				}
			)

			.retry(2);
	}

	PostReviewers(appModel: IApplicationModel) {
		let body = {
			Reviewers: this.PostingReviewers,
			applicationNumber: appModel.Application.ApplicationNumber,
			applicationId: appModel.Application.Id,
			applicationStatus: this._updateStatusTo
		};

		let endPoint = environment.APILocation + "reviewer/save";

		return this._serverSrv
			.PostWithAuth(
				this._userSrv.Data.contact.AcepId,
				endPoint,
				JSON.stringify(body)
			)
			.map(m => m.json())
			.do(data => {
				// refreshes reviewers from server
				this.GetReviewers(appModel.Application.Id).subscribe();
				// // refreshes members from server
				// this._applicationService.getByNumber(this._data._detailResolver.application.ApplicationNumber.toString()).subscribe();
			})
			.retry(2);
	}


	PostPreQCEmails(appModel: IApplicationModel, toemails: string) {
		let body = {
			applicationNumber: appModel.Application.ApplicationNumber,
			applicationId: appModel.Application.Id,
			toEmails: toemails
		};

		let endPoint = environment.APILocation + "reviewer/preqc";

		return this._serverSrv
			.PostWithAuth(
				this._userSrv.Data.contact.AcepId,
				endPoint,
				JSON.stringify(body)
			)
			.map(m => m.json())
			.do(data => {
				// refreshes reviewers from server
				//this.GetReviewers(appModel.Application.Id).subscribe();
				// // refreshes members from server
				// this._applicationService.getByNumber(this._data._detailResolver.application.ApplicationNumber.toString()).subscribe();
			});

	}


	//   UpdateAndEmail(
	// 	status: ApplicationStatusEnum,
	// 	notify: INotify
	//   ): Promise<INotify> {
	// 	return new Promise((resolve, reject) => {

	// 	  // update the updateStatus
	// 	  this._applicationSrv.updateApplicationStatus(status)
	// 		.subscribe(app => {

	// 		  if (app && status !== ApplicationStatusEnum.Cancelled) {
	// 			let returnedApp = <IApplication>JSON.parse(app);
	// 			'UpdateAndEmail reset application'.log(this.name);
	// 			// this._applicationService.Application = returnedApp;

	// 			'UpdateAndEmail reset discussions'.log(this.name);
	// 			this.LoadDiscussions();
	// 		  }
	// 		  resolve(notify);
	// 		}, err => {

	// 		  // this._messageService.DisplayTopError('Unable to change status to ' + s, true);
	// 		  reject(err);
	// 		});

	// 	  // END PROMISE
	// 	});
	//   }

	private _updateReviewers(r: IReviewersModel) {
		this._reviewers = {
			All: r.Reviewers,
			QCs: r.Reviewers.filter(q => q.Reviewer.PositionId === RoleEnum.QC),
			Panels: r.Reviewers.filter(
				pa => pa.Reviewer.PositionId === RoleEnum.Panel
			),
			Sites: r.Reviewers.filter(
				q => q.Reviewer.PositionId === RoleEnum.Site
			),
			Boards: r.Reviewers.filter(
				br => br.Reviewer.PositionId === RoleEnum.Board
			), // || br.PositionId === 6),
			Aceps: r.Reviewers.filter(
				ac => ac.Reviewer.PositionId === RoleEnum.Acep
			)
		};
		//
		// let panelsSelected = this._reviewers.Panels.filter(p => p.Reviewer.Selected === true);
		// let boardsSelected = this._reviewers.Boards.filter(b => b.Reviewer.Selected === true);
		// // if no boards have been chosenthis._currentReviewers = {
		// 	QCs: [],
		// 	Panels: [],
		// 	Sites: [],
		// 	Boards: []
		// };
		// // select all boards
		// if (!boardsSelected || boardsSelected.length === 0) {
		// 	this._reviewers.Boards.forEach(b => {
		// 		// if this board is not already selected in panels
		// 		// select PositionId
		// 		// else disable it
		// 		if (!panelsSelected.find(p => p.Reviewer.ContactId === b.Reviewer.ContactId)) {
		// 			b.Reviewer.Selected = true;
		// 		} else {
		// 			b.Reviewer.Selected = false;
		// 			b.Reviewer.Disabled = true;
		// 		}

		// 	});
		// } else {
		// 	this._currentReviewers.Boards.push(...boardsSelected);
		// 	boardsSelected.forEach(b => {
		// 		let panel = this._reviewers.Panels.find(p => p.Reviewer.ContactId === b.Reviewer.ContactId);
		// 		if (panel) {
		// 			panel.Reviewer.Disabled = true;
		// 			panel.Reviewer.Selected = false;
		// 		}
		// 	});
		// }

		// if (panelsSelected && panelsSelected.length > 0) {
		// 	this._currentReviewers.Panels.push(...panelsSelected);
		// 	if (panelsSelected.length >= 2) {
		// 		let pUnselected = this._reviewers.Panels.filter(p => p.Reviewer.Selected === false);
		// 		if (pUnselected && pUnselected.length > 0) {
		// 			pUnselected.forEach(p => {
		// 				p.Reviewer.Disabled = true;
		// 			});
		// 		}
		// 	}
		// }
		this._logSrv.Debug(this.name, ["Updating allreviewers", r]);
		this._allReviewers.next(this._reviewers.All);
		this._qcs.next(this._reviewers.QCs);
		this._panels.next(this._reviewers.Panels);
		this._sites.next(this._reviewers.Sites);
		this._boards.next(this._reviewers.Boards);
		this._aceps.next(this._reviewers.Aceps);
		this._members.next(this.PostingReviewers);
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/services/reviewer/reviewer.service.ts